'use client';
/* eslint-disable i18next/no-literal-string -- global-error renders when the root layout (and its i18n providers) has thrown, so it cannot call t(); copy is intentionally default-locale-only English. */
import {useEffect} from 'react';
import {DEFAULT_LOCALE, getTextDirection} from '../i18n/locale';

// Last-resort boundary shared by every tenant: replaces the root layout itself
// when it throws (e.g. a data fetch fails), so it must render its own <html>/<body>
// and cannot rely on the theme or i18n providers. Copy is intentionally in the
// default locale only. Each app's app/global-error.tsx re-exports this as default.
//
// Deliberately free of MUI/emotion: as a root-level client boundary it gets its own
// Turbopack chunk group, so any MUI import here ships a second copy of MUI on every
// page load (see perf/home-lcp-investigation).
const STYLES = `
.ge{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;min-height:100vh;padding:80px 18px}
.ge img{width:175px;height:auto;margin-bottom:10px}
.ge h1{margin:0;font-weight:700;font-size:20px}
.ge p{margin:6px 0 0;font-size:16px;max-width:287px;opacity:.75}
.ge button{margin-top:24px;padding:.65rem 1.5rem;border:1px solid currentColor;border-radius:.5rem;background:transparent;cursor:pointer;font:inherit;color:inherit}
@media (min-width:900px){.ge{padding:150px 18px}.ge img{width:210px;margin-bottom:16px}.ge h1{font-size:28px}.ge p{margin-top:8px;font-size:18px;max-width:382px}}
`;

export function GlobalError({error, reset}: {error: Error & {digest?: string}; reset: () => void}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang={DEFAULT_LOCALE} dir={getTextDirection(DEFAULT_LOCALE)}>
      <body style={{margin: 0, fontFamily: 'system-ui, sans-serif'}}>
        <style>{STYLES}</style>
        <section className="ge">
          <img src="/not-found.svg" alt="" />
          <h1>Something went wrong</h1>
          <p>We hit an unexpected error. Please try again.</p>
          <button type="button" onClick={reset}>
            Try again
          </button>
        </section>
      </body>
    </html>
  );
}
